import useBooleanConfig from './useBooleanConfig';

// variable for WebSocket debug logging (separate from feature enablement)
export const WEBSOCKET_DEBUG = process.env.NEXT_PUBLIC_WEBSOCKET_DEBUG === 'true';

export const useWebsocketFeature = (): boolean => {
  return useBooleanConfig('enableWebsocketForRachelInbox', true);
};
